import { FoundColor, GameMode, IAPColor } from '@/types/types';
import { starThresholds } from './scoreResultHelper';
import { useGameStore } from '../../store/gameStore';
import * as LucideIcons from 'lucide-react';
import { Capacitor } from '@capacitor/core';
import { useSyncStore } from '../..//store/syncStore';

const isWeb = Capacitor.getPlatform() === 'web';

export const isKoFiUnlocked = () => {
  return localStorage.getItem('kofiUnlockValidated') === 'true';
};

export const hasStatSyncUnlocked = () => {
  return isWeb ? isKoFiUnlocked() : useSyncStore.getState().statSyncPurchased;
};

export const hasGalaxyUnlocked = () => {
  const state = useGameStore.getState();
  const highScoreStats = state.gameStats;
  const gameModes: GameMode[] = ['blitzSimple', 'blitzDeluxe', 'endlessSimple', 'endlessDeluxe'];

  return gameModes.every((mode) => {
    const highScore = highScoreStats[mode].pointsHighScore;
    const maxThreshold = starThresholds[mode].slice(-1)[0];
    return highScore >= maxThreshold;
  });
};

export const hasfireUnlocked = () => {
  return isWeb
    ? localStorage.getItem('kofiUnlockValidated') === 'true'
    : useGameStore.getState().unlockedColors.includes('fire');
};

export const hasIceUnlocked = () => {
  return isWeb
    ? localStorage.getItem('kofiUnlockValidated') === 'true'
    : useGameStore.getState().unlockedColors.includes('ice');
};

export const colorUnlockables: {
  color: FoundColor;
  letters: string[];
  unlockAmount?: number;
  customUnlockCheck?: () => boolean;
  hideToast?: boolean;
  chipIcon?: keyof typeof LucideIcons;
  chipText?: string;
  unlockColorId?: IAPColor;
  price?: string;
}[] = [
  { color: 'green', letters: ['G', 'R', 'N'], unlockAmount: 0 },
  { color: 'blue', letters: ['B', 'L', 'U'], unlockAmount: 100 },
  { color: 'purple', letters: ['P', 'R', 'P'], unlockAmount: 250 },
  { color: 'pink', letters: ['P', 'N', 'K'], unlockAmount: 500 },
  { color: 'red', letters: ['R', 'E', 'D'], unlockAmount: 750 },
  { color: 'rainbow', letters: ['R', 'B', 'W'], unlockAmount: 1000 },
  {
    color: 'galaxy',
    letters: ['G', 'X', 'Y'],
    customUnlockCheck: hasGalaxyUnlocked,
    chipIcon: 'Crown',
    chipText: ' All Modes',
  },
  {
    color: 'fire',
    letters: ['F', 'R', 'E'],
    customUnlockCheck: hasfireUnlocked,
    hideToast: true,
    chipIcon: 'DollarSign',
    chipText: isWeb ? ' Ko-fi' : ' 1.99',
    unlockColorId: isWeb ? undefined : 'unlock_fire_color',
    price: isWeb ? undefined : '$1.99',
  },
  {
    color: 'ice',
    letters: ['I', 'C', 'E'],
    customUnlockCheck: hasIceUnlocked,
    hideToast: true,
    chipIcon: 'DollarSign',
    chipText: isWeb ? ' Ko-fi' : ' 1.99',
    unlockColorId: isWeb ? undefined : 'unlock_ice_color',
    price: isWeb ? undefined : '$1.99',
  },
];
